import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'roblex-rating',
    templateUrl: './rating.component.html',
    styleUrls: ['./rating.component.scss'],
})
export class RatingComponent {
    /**
     * Stars  of rating component
     */
    private stars = [
        {
            id: 1,
            icon: 'roblex roblex-star-regular',
            class: 'star-gray star-hover star',
        },
        {
            id: 2,
            icon: 'roblex roblex-star-regular',
            class: 'star-gray star-hover star',
        },
        {
            id: 3,
            icon: 'roblex roblex-star-regular',
            class: 'star-gray star-hover star',
        },
        {
            id: 4,
            icon: 'roblex roblex-star-regular',
            class: 'star-gray star-hover star',
        },
        {
            id: 5,
            icon: 'roblex roblex-star-regular',
            class: 'star-gray star-hover star',
        },
    ];
    /**
     * Input value of rating component
     */
    @Input() public value!: number;
    /**
     * Input disabled of rating component
     */
    @Input() public disabled!: boolean;
    /**
     * Output value changed of rating component
     */
    @Output() valueChanged: EventEmitter<number> = new EventEmitter();
    /**
     * Selects star
     * @param value number
     */
    selectStar(value: number): void {
        this.stars.filter((star) => {
            if (star.id <= value) {
                star.icon = 'roblex roblex-star-solid';
            } else {
                star.icon = 'roblex roblex-star-regular';
            }

            return star;
        });
        this.value = value;
        this.valueChanged.emit(this.value);
    }
}
